import { INIT_ROOT } from '../actionTypes';

export default function api(state, { type, payload }) {
  if (type !== INIT_ROOT) {
    return state || {};
  }

  const { uiPath, contextPath, appResources } = payload;
  const { language, country, brand, carline, year, bodyStyle } = appResources;
  const legacyServicesPath = `${contextPath}/services`;
  const servicesPath = `${contextPath}/api/v2`;
  const v3ServicesPath = `${contextPath}/api/v3`;

  const modelPath = `${language}/${country}/${brand}/${carline}/${year}/${bodyStyle}`;

  return {
    legacyServicesPath,
    servicesPath,
    v3ServicesPath,
    modelPath,
    uiPath,
  };
}
